/** Briefly identify an actionable destination after a purposeful handoff. */
export function spotlightAction(id:string){
  if(typeof document==='undefined')return;
  window.setTimeout(()=>{
    const destination=document.getElementById(id);
    if(!destination)return;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    destination.scrollIntoView({behavior:reduced?'instant':'smooth',block:'center'});
    destination.classList.remove('actionSpotlight');
    // Restart a previously triggered highlight without creating a permanent selected state.
    void destination.offsetWidth;
    destination.classList.add('actionSpotlight');
    window.setTimeout(()=>destination.classList.remove('actionSpotlight'),1700);
    const field=destination.matches('input,textarea,select')?destination:destination.querySelector('input,textarea,select');
    if(field instanceof HTMLElement&&!reduced)field.focus({preventScroll:true});
    else if(destination.tabIndex>=0)destination.focus({preventScroll:true});
  },85);
}
